import { Box, Container, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import HttpServices from 'src/services/httpService';
import { userModuleURL } from 'src/services/urlService';
import { CommonHelper } from 'src/utils/commonHelper';

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

const VerifyEmailComponent = () => {
  const { t: translate } = useTranslation();

  const [isUserVerified, setUserverified] = useState(false);
  const [isWrongCode, setWrongCode] = useState(false);

  useEffect(() => {
    checkAndGetToken();
  }, []);
  const successCallback = (data, message) => {
    setUserverified(true);
    window.location.href = CommonHelper.DefaultPermissionRoute;
  };
  const failureCallback = (message) => {
    setWrongCode(true);
  };
  const checkAndGetToken = () => {
    const popupWindowURL = new URL(window.location.href);
    const token = popupWindowURL.searchParams.get('token');
    if (token) {
      let verifyForm = {
        token,
      };
      let postProps = {
        url: userModuleURL.verifyUser,
        body: verifyForm,
        successCallback,
        failureCallback,
      };
      HttpServices.Post(postProps);
    }
  };

  return (
    <>
      <Helmet>
        <title> {translate('verify_user.title')} </title>
      </Helmet>

      {isUserVerified ? (
        <Container>
          <StyledContent sx={{ textAlign: 'center', alignItems: 'center' }}>
            <Typography variant="h3" paragraph>
              {translate('verify_email.email_verification')}
            </Typography>

            <Typography sx={{ color: 'text.secondary', mb: 1.5 }}>
              {translate('verify_email.verified_successfully')}
            </Typography>

            <Box component="img" src="/assets/email_verification.png" />
          </StyledContent>
        </Container>
      ) : (
        <>
          {isWrongCode ? (
            <Container>
              <StyledContent sx={{ textAlign: 'center', alignItems: 'center' }}>
                <Typography variant="h3" paragraph>
                  {translate('verify_email.token_expired')}
                </Typography>

                <Typography sx={{ color: 'text.secondary' }}>
                  {translate('verify_email.contact_your_administrator')}
                </Typography>
              </StyledContent>
            </Container>
          ) : (
            <Container>
              <StyledContent sx={{ textAlign: 'center', alignItems: 'center' }}>
                <Typography variant="h3" paragraph>
                  {translate('verify_email.validating_your_token')}
                </Typography>

                <Typography sx={{ color: 'text.secondary' }}>
                  {translate('verify_email.validating_your_email')}
                </Typography>
              </StyledContent>
            </Container>
          )}
        </>
      )}
    </>
  );
};
export default VerifyEmailComponent;
